import React from 'react';
import {Table as BaseTable} from 'desktop/sports/f1/players-list/classic';

class Table extends BaseTable {}

export {Table};
